module.exports = __webpack_public_path__ + "img/mobile.f687c1d4.png";